import NextLink from 'next/link';
import { useTranslation } from 'react-i18next';
import styles from '../../HomepageSections.module.scss';
import { atlasCell, atlasLandDots, atlasLive, atlasPipeline, atlasPings } from './coverageMapData';

const CountryCoverageMap = () => (
  <svg className={styles.countryCoverageMap} viewBox={`0 0 ${64 * atlasCell} ${30 * atlasCell}`} aria-hidden='true'>
    {atlasLandDots.map(([row, column]) => (
      <circle
        className={styles.mapLandDot}
        cx={column * atlasCell + atlasCell / 2}
        cy={row * atlasCell + atlasCell / 2}
        r='3'
        key={`land-${row}-${column}`}
      />
    ))}
    {atlasLive.map(([row, column], index) => (
      <circle
        className={styles.mapLiveDot}
        cx={column * atlasCell + atlasCell / 2}
        cy={row * atlasCell + atlasCell / 2}
        r='4'
        style={{ animationDelay: `${(index * 0.55).toFixed(2)}s` }}
        key={`live-${row}-${column}`}
      />
    ))}
    {atlasPipeline.map(([row, column], index) => (
      <circle
        className={styles.mapPipelineDot}
        cx={column * atlasCell + atlasCell / 2}
        cy={row * atlasCell + atlasCell / 2}
        r='3.5'
        style={{ animationDelay: `${(index * 0.9).toFixed(2)}s` }}
        key={`pipeline-${row}-${column}`}
      />
    ))}
    {atlasPings.map(([row, column], index) => (
      <circle
        className={styles.mapPingRing}
        cx={column * atlasCell + atlasCell / 2}
        cy={row * atlasCell + atlasCell / 2}
        r='4'
        style={{ animationDelay: `${(index * 2.2).toFixed(2)}s` }}
        key={`ping-${row}-${column}`}
      />
    ))}
  </svg>
);

export const ClosingCta = () => {
  const { t } = useTranslation('landing');

  return (
    <section className={styles.closingCta}>
      <div className={styles.closingMap}>
        <CountryCoverageMap />
      </div>
      <div>
        <span className={styles.eyebrow}>{t('homepage.closing.eyebrow')}</span>
        <h2>{t('homepage.closing.title')}</h2>
        <p>{t('homepage.closing.description')}</p>
        <div className={styles.ctaActions}>
          <NextLink href='/#contact-us'>{t('homepage.closing.getDemo')}</NextLink>
          <NextLink href='/sign-up/'>
            {t('homepage.closing.start')} <span>→</span>
          </NextLink>
        </div>
        <small>{t('homepage.closing.walkthrough')}</small>
        <div className={styles.ctaProof}>
          <span>{t('homepage.closing.proof.countries')}</span>
          <i>·</i>
          <span>{t('homepage.closing.proof.roadmap')}</span>
          <i>·</i>
          <span>{t('homepage.closing.proof.accreditation')}</span>
        </div>
      </div>
    </section>
  );
};
